import React from "react";
import { ExclamationCircle } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { TransElement } from "../../../utils";
import { useUserQuery } from "../../../graphql/menu.hooks";

interface TrialToastProps {
  checkoutUrl: string;
}

export const TrialToast = ({ checkoutUrl }: TrialToastProps) => {
  const { t } = useTranslation();

  const { data: userData } = useUserQuery();

  const moveToStripePayment = () => {
    window.location.href = checkoutUrl;
  };

  if (!userData?.user?.userPremium?.trialActive) {
    return <></>;
  }

  return (
    <div className="col-12 p-3 border border-secondary bg-warning-light d-flex flex-column flex-md-row align-items-center justify-content-between rounded-3 mb-4 gap-3 gap-md-0">
      <div className="d-flex flex-wrap align-items-center">
        <ExclamationCircle className="text-secondary me-2 fs-5 align-self-baseline mt-1" />
        <p className="d-none d-md-block text-secondary m-0 text-break fs-5 fw-bold">
          <TransElement
            i18nKey="payment.trialToastText"
            values={{
              count: userData?.user?.userPremium?.daysUntilEnd,
            }}
          />
        </p>
        <p
          className="d-block d-md-none text-secondary mb-0 text-break fs-6 fw-bold"
          style={{ marginTop: "2px" }}
        >
          <TransElement
            i18nKey="payment.trialToastText"
            values={{
              count: userData?.user?.userPremium?.daysUntilEnd,
            }}
          />
        </p>
      </div>
      <button
        onClick={moveToStripePayment}
        className="btn btn-primary fw-normal col-12 col-md-auto text-white white-hover fs-7 fw-bold rounded-2"
        style={{ padding: "5.5px 24px" }}
      >
        {t("payment.Upgrade to Premium")}
      </button>
    </div>
  );
};
